"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: kyve/multi_coin_rewards/v1beta1/tx.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgClientImpl = exports.MsgServiceName = exports.MsgSetMultiCoinRewardsDistributionPolicyResponse = exports.MsgSetMultiCoinRewardsDistributionPolicy = exports.MsgToggleMultiCoinRewardsResponse = exports.MsgToggleMultiCoinRewards = exports.MsgUpdateParamsResponse = exports.MsgUpdateParams = exports.protobufPackage = void 0;
/* eslint-disable */
var wire_1 = require("@bufbuild/protobuf/wire");
var types_1 = require("./types");
exports.protobufPackage = "kyve.multi_coin_rewards.v1beta1";
function createBaseMsgUpdateParams() {
    return { authority: "", payload: "" };
}
exports.MsgUpdateParams = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.payload !== "") {
            writer.uint32(18).string(message.payload);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.authority = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.payload = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            authority: isSet(object.authority) ? globalThis.String(object.authority) : "",
            payload: isSet(object.payload) ? globalThis.String(object.payload) : "",
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.authority !== "") {
            obj.authority = message.authority;
        }
        if (message.payload !== "") {
            obj.payload = message.payload;
        }
        return obj;
    },
    create: function (base) {
        return exports.MsgUpdateParams.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMsgUpdateParams();
        message.authority = (_a = object.authority) !== null && _a !== void 0 ? _a : "";
        message.payload = (_b = object.payload) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
exports.MsgUpdateParamsResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.MsgUpdateParamsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseMsgUpdateParamsResponse();
        return message;
    },
};
function createBaseMsgToggleMultiCoinRewards() {
    return { creator: "", enabled: false };
}
exports.MsgToggleMultiCoinRewards = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.enabled !== false) {
            writer.uint32(16).bool(message.enabled);
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgToggleMultiCoinRewards();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.creator = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.enabled = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
            enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.creator !== "") {
            obj.creator = message.creator;
        }
        if (message.enabled !== false) {
            obj.enabled = message.enabled;
        }
        return obj;
    },
    create: function (base) {
        return exports.MsgToggleMultiCoinRewards.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b;
        var message = createBaseMsgToggleMultiCoinRewards();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.enabled = (_b = object.enabled) !== null && _b !== void 0 ? _b : false;
        return message;
    },
};
function createBaseMsgToggleMultiCoinRewardsResponse() {
    return {};
}
exports.MsgToggleMultiCoinRewardsResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgToggleMultiCoinRewardsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.MsgToggleMultiCoinRewardsResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseMsgToggleMultiCoinRewardsResponse();
        return message;
    },
};
function createBaseMsgSetMultiCoinRewardsDistributionPolicy() {
    return { creator: "", policy: undefined };
}
exports.MsgSetMultiCoinRewardsDistributionPolicy = {
    encode: function (message, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.policy !== undefined) {
            types_1.MultiCoinDistributionPolicy.encode(message.policy, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgSetMultiCoinRewardsDistributionPolicy();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.creator = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.policy = types_1.MultiCoinDistributionPolicy.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (object) {
        return {
            creator: isSet(object.creator) ? globalThis.String(object.creator) : "",
            policy: isSet(object.policy) ? types_1.MultiCoinDistributionPolicy.fromJSON(object.policy) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.creator !== "") {
            obj.creator = message.creator;
        }
        if (message.policy !== undefined) {
            obj.policy = types_1.MultiCoinDistributionPolicy.toJSON(message.policy);
        }
        return obj;
    },
    create: function (base) {
        return exports.MsgSetMultiCoinRewardsDistributionPolicy.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a;
        var message = createBaseMsgSetMultiCoinRewardsDistributionPolicy();
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.policy = (object.policy !== undefined && object.policy !== null)
            ? types_1.MultiCoinDistributionPolicy.fromPartial(object.policy)
            : undefined;
        return message;
    },
};
function createBaseMsgSetMultiCoinRewardsDistributionPolicyResponse() {
    return {};
}
exports.MsgSetMultiCoinRewardsDistributionPolicyResponse = {
    encode: function (_, writer) {
        if (writer === void 0) { writer = new wire_1.BinaryWriter(); }
        return writer;
    },
    decode: function (input, length) {
        var reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        var end = length === undefined ? reader.len : reader.pos + length;
        var message = createBaseMsgSetMultiCoinRewardsDistributionPolicyResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON: function (_) {
        return {};
    },
    toJSON: function (_) {
        var obj = {};
        return obj;
    },
    create: function (base) {
        return exports.MsgSetMultiCoinRewardsDistributionPolicyResponse.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (_) {
        var message = createBaseMsgSetMultiCoinRewardsDistributionPolicyResponse();
        return message;
    },
};
exports.MsgServiceName = "kyve.multi_coin_rewards.v1beta1.Msg";
var MsgClientImpl = /** @class */ (function () {
    function MsgClientImpl(rpc, opts) {
        this.service = (opts === null || opts === void 0 ? void 0 : opts.service) || exports.MsgServiceName;
        this.rpc = rpc;
        this.UpdateParams = this.UpdateParams.bind(this);
        this.ToggleMultiCoinRewards = this.ToggleMultiCoinRewards.bind(this);
        this.SetMultiCoinRewardDistributionPolicy = this.SetMultiCoinRewardDistributionPolicy.bind(this);
    }
    MsgClientImpl.prototype.UpdateParams = function (request) {
        var data = exports.MsgUpdateParams.encode(request).finish();
        var promise = this.rpc.request(this.service, "UpdateParams", data);
        return promise.then(function (data) { return exports.MsgUpdateParamsResponse.decode(new wire_1.BinaryReader(data)); });
    };
    MsgClientImpl.prototype.ToggleMultiCoinRewards = function (request) {
        var data = exports.MsgToggleMultiCoinRewards.encode(request).finish();
        var promise = this.rpc.request(this.service, "ToggleMultiCoinRewards", data);
        return promise.then(function (data) { return exports.MsgToggleMultiCoinRewardsResponse.decode(new wire_1.BinaryReader(data)); });
    };
    MsgClientImpl.prototype.SetMultiCoinRewardDistributionPolicy = function (request) {
        var data = exports.MsgSetMultiCoinRewardsDistributionPolicy.encode(request).finish();
        var promise = this.rpc.request(this.service, "SetMultiCoinRewardDistributionPolicy", data);
        return promise.then(function (data) { return exports.MsgSetMultiCoinRewardsDistributionPolicyResponse.decode(new wire_1.BinaryReader(data)); });
    };
    return MsgClientImpl;
}());
exports.MsgClientImpl = MsgClientImpl;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=tx.js.map